import { Button, Card, Col, Form, Input, Modal, Radio, Row, Select, Spin, message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { LoadingOutlined } from '@ant-design/icons';
import { debounce } from 'lodash';


const GangDie = ({
    setPageHeader
}) => {
    if (setPageHeader) {
        setPageHeader("Cavity Config");
    };

    const [formData, setFormData] = useState([]);
    const [searchVal, setSearchVal] = useState('');
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchedParts, setSearchedParts] = useState([]);
    const [selectedLid, setSelectedLid] = useState("");
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    const [loadLineAccess, setLoadLineAccess] = useState(null);
    const [pageData, setPageData] = useState();
    const [partsForm] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [partsModal, setPartsModal] = useState({
        open: false,
        modalData: null,
        loading: false
    });


    const fetchLineAccess = () => {
        liracrypt
            .get("/linedashboard/access", {})
            .then(({ data }) => {

                if (data.data.length === 1) {
                    setSelectedLid(data.data[0]["_id"]);
                } else {
                    setLoadLineAccess(data.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                ApiErrorComp();
            });
    };

    const changeFormData = (data) => {
        setFormData(data);
        if (!data.length) {
            localStorage.removeItem('gangdieChanges');
            return;
        }
        localStorage.setItem('gangdieChanges', JSON.stringify(data));
    }

    const searchPart = useCallback(debounce((value) => {
        setSearchedParts(pageData?.parts.filter(x => x.toLowerCase().includes(value.toLowerCase())))
    }, 800), [pageData]);

    const getData = ({ lid }) => {
        setLoading(true);
        liracrypt.get('/gangdieconfig', { dn: 'Z_Hldx_GangConfig', lid, ...searchParams })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setLoading(false);
                    setPageData(data.data);
                    setSearchedParts(data.data.parts);
                    changeFormData([]);
                } else {
                    message.error(data.message || 'Something went wrong');
                    changeFormData([]);
                }
            }).catch(err => {
                console.error(err);
                changeFormData([]);
                ApiErrorComp();
            })
    };

    const onPartChange = ({ selectedPart }) => {
        let selectedData = { ...searchParams, indx: partsModal.modalData.indx, text: selectedPart, lid: selectedLid, lid_001: selectedLid };
        let index = formData.findIndex(x => x.indx === partsModal.modalData.indx);
        if (index < 0) {
            changeFormData([...formData, selectedData]);
        } else {
            let fData = [...formData];
            fData[index] = selectedData;
            changeFormData(fData);
        };
        let _pageData = { ...pageData };
        _pageData.dieConfig[partsModal.modalData.indx].text = selectedPart;
        setPageData(_pageData);
        partsForm.resetFields();
        toggleModal({});
    }
    const onPartSelect = () => {
        setBtnLoading(true);
        liracrypt.patch('/gangdieconfig', formData)
            .then(({ data }) => {
                if (data.isSuccess) {
                    message.success(data.message || 'Submitted Successfully');
                    setBtnLoading(false);
                    getData({ lid: selectedLid });
                } else {
                    setBtnLoading(false);
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                console.error(err);
                setBtnLoading(false);
                ApiErrorComp();
            })
    };


    const selectLid = ((!selectedLid && !searchParams.lid) &&
        <div className="dash">
            <Card
                title={
                    <span style={{ fontWeight: 600 }}>Please select a line</span>
                }
                bordered={false}
                style={{
                    width: "600px",
                    margin: "10% auto",
                    backgroundColor: "#424358",
                    border: 0,
                    borderRadius: "10px",
                    fontWeight: "600",
                    padding: "10px",
                }}
            >
                {loadLineAccess ? (
                    <Form.Item
                        className="selectLine"
                        rules={[{ required: true, message: "Select a line" }]}
                    >
                        <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select a line"
                            optionFilterProp="children"
                            onChange={(value) => {
                                setSelectedLid(value);
                            }}
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {loadLineAccess.map((obj) => (
                                <Select.Option value={obj._id}>{obj.lame}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : (
                    <div className="Loading">
                        <Spin indicator={antIcon} />
                    </div>
                )}
            </Card>
        </div>
    )

    useEffect(() => {
        if (selectedLid) {
            getData({ lid: selectedLid });
        } else {
            fetchLineAccess();
        }
        const handleTabClose = (event) => {
            if (localStorage.getItem('gangdieChanges')) {
                event.preventDefault();
                console.log('beforeunload event triggered');
                return (event.returnValue = 'Are you sure you want to exit?');
            }
        };

        window.addEventListener('beforeunload', handleTabClose);

        return () => {
            window.removeEventListener('beforeunload', handleTabClose);
        };
    }, [search, selectedLid]);

    const toggleModal = ({ open = false, modalData = null, loading = false }) => {
        if (!open) {
            setSearchedParts(pageData?.parts);
            setSearchVal('');
        }
        setPartsModal({ open, modalData, loading });
    };

    const onPartClick = (data) => {
        if (data.isClickable) {
            toggleModal({
                open: true,
                modalData: data
            })
        }
    }

    return (
        <div className='gangdie'>
            {selectLid}
            {
                selectedLid && (
                    <>
                        {
                            loading ?
                                <div className='Loading'>
                                    <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} />
                                </div> :
                                <div>
                                    {
                                        formData.length && (
                                            <p className='gangdie-note'>
                                                <marquee direction="left">Note**You have to press the submit button below to save your changes</marquee>
                                            </p>
                                        )
                                    }

                                    <Row>
                                        {
                                            pageData?.dieConfig.map((x, i) => (
                                                <Col key={`gangdie-${i}`} span={pageData?.blocks === 8 ? 6 : 4}>
                                                    <div onClick={() => onPartClick({ ...x })} className="gangdie-block" style={{ backgroundColor: x.colr, cursor: x.isClickable ? 'pointer' : undefined }}>
                                                        <p className='gangdie-cav'>{x.cav || ''}</p>
                                                        <p className='gangdie-text'>{x.text || ''}</p>
                                                    </div>
                                                </Col>
                                            ))
                                        }
                                        {
                                            pageData && (
                                                <div style={{ marginTop: 20, width: '100%', display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    {/* <Button onClick={() => { changeFormData([]); setPageData(initPageData) }} style={{ marginRight: 10 }} size='large' htmlType='button' type='primary' danger>Cancel</Button> */}
                                                    <Button loading={btnLoading} disabled={!formData.length || btnLoading} size='large' type="primary" onClick={onPartSelect}>Submit</Button>
                                                </div>
                                            )
                                        }
                                    </Row>
                                </div>
                        }
                    </>
                )
            }

            <Modal
                destroyOnClose={true}
                width={'40%'} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={partsModal.open} title="Parts" onCancel={() => {
                    toggleModal({});
                    partsForm.resetFields();
                }}>
                <div>
                    <Col span={24}>
                        <Form.Item>
                            <Input value={searchVal} onChange={(e) => {
                                setSearchVal(e.target.value);
                                searchPart(e.target.value)
                            }} placeholder='Search' type="search" />
                        </Form.Item>
                    </Col>
                    <Form
                        name="partSelectionForm"
                        form={partsForm}
                        onFinish={onPartChange}
                    >
                        <Form.Item name="selectedPart" className='gangdie-parts-container'>
                            <Radio.Group
                                style={{ fontWeight: 600, width: "100%" }}
                            >
                                {
                                    searchedParts.map((part, partIndex) => (
                                        <Radio key={partIndex} value={part} style={{ fontWeight: 600 }}>
                                            {part}
                                        </Radio>
                                    ))
                                }
                            </Radio.Group>
                        </Form.Item>
                        <div style={{ marginTop: 20, width: '100%', display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Button onClick={() => { partsForm.resetFields(); toggleModal({}) }} style={{ marginRight: 10 }} size='large' htmlType='button' type='primary' danger>Cancel</Button>
                            <Button size='large' type="primary" htmlType='submit'>Submit</Button>
                        </div>
                    </Form>
                </div>
            </Modal>

        </div >
    )
};

export default GangDie;